import { EventEmitter, Input, Output, ViewContainerRef } from '@angular/core';

import { InputConverter } from '../../../inputConverter';
import { LayerService } from '../../../services/layer.service';
import { MapCoreLayer } from '../../../types';
import { BaseComponent } from '../../base.component';

export abstract class BaseSymbolEditorComponent extends BaseComponent {

    protected esriLayer: MapCoreLayer;
    protected _layerSymbol: __esri.Symbol;
    protected _uniqueLayerId: string;
    protected layerService: LayerService;

    @Output() readonly applyColorToEntireLayerChange = new EventEmitter<boolean>();
    @Output() readonly colorChange = new EventEmitter<string>();

    constructor(_vcr: ViewContainerRef, layerService: LayerService) {
        super(_vcr);
        this.layerService = layerService;
    }

    @Input() set uniqueLayerId(value: string) {
        this._uniqueLayerId = value;
        if (value) {
            this.esriLayer = this.layerService.getEsriLayerByUniqueId(this.uniqueLayerId);
        }
    }
    get uniqueLayerId(): string {
        return this._uniqueLayerId;
    }

    @Input() set layerSymbol(value: NonNullable<__esri.Symbol>) {
        this._layerSymbol = value;
        this.bindForm();
    }
    get layerSymbol(): __esri.Symbol {

        return this._layerSymbol;
    }

    @Input()
    applyColorToEntireLayer = false;

    @Input()
    symbolColor: string;

    originalColor: string;
    outlineColor: string;
    originalOutlineColor: string;

    @Input()
    @InputConverter()
    multipleSymbols: boolean = false;

    @Input()
    public cancel = () => {
        this.uniqueLayerId = null;
        this.layerSymbol = null;
    }

    bindForm() {
        this.symbolColor = this.originalColor;
    }

    updateColorFromPicker(evt, colorProperty = 'symbolColor') {
        this[colorProperty] = evt;

        if (this.applyColorToEntireLayer && this.outlineColor) {
            this.outlineColor = evt;
        }

        if (colorProperty === 'symbolColor') {
            this.colorChange.emit(evt);
        }
    }

    applyColorToEntireLayerCheckboxChange() {
        if (this.applyColorToEntireLayer) {
            this.applyColorToEntireLayerChange.emit(true);
            this.colorChange.emit(this.symbolColor);
            this.outlineColor = this.symbolColor;
        } else {
            this.applyColorToEntireLayerChange.emit(false);
        }
    }

    cancelColorChange(colorProperty = 'symbolColor') {
        switch (colorProperty) {
            case 'layerColor':
                this.esriLayer.mapcoreProps.color = this.originalColor;
                break;

            case 'outlineColor':
                this.outlineColor = this.originalOutlineColor;
                break;

            default:
                this.symbolColor = this.originalColor;
                break;
        }
    }
}
